// extracted by mini-css-extract-plugin
export default {"description":"changeBasic_description__AZz0K","content":"changeBasic_content__Ye0Ng","contentItem":"changeBasic_contentItem__Pojv0","mt12":"changeBasic_mt12__4Rf65"};